export default [
    { id: 'none', name: 'none' },
    { id: 'wifi', name: 'wifi' },
    { id: 'wifi|ble', name: 'wifi|ble' },
    { id: 'nfc', name: 'nfc' },
    { id: 'dual', name: 'dual' },
];
